import {
  GET_COMBO_LOAI_TAI_SAN,
  GET_COMBO_LOAI_TAI_SAN_SUCCESS,
  GET_COMBO_LOAI_TAI_SAN_FAILURE,
  POST_LOAI_TAI_SAN_TM,
  POST_LOAI_TAI_SAN_TM_SUCCESS,
  POST_LOAI_TAI_SAN_TM_FAILURE,
  SHOW_MODAL_LOAI_TAI_SAN,
} from "actions/LoaiTaiSan/actionTypes";

const initialState = {
  loaiTaiSanLoading: false,
  comboLoaiTaiSan: [],
  comboLoaiTaiSanLoaded: false,
  isShowModalLoaiTaiSan: false,
};

const getComboLoaiTaiSan = (state, action) => ({
  ...state,
  loaiTaiSanLoading: true,
  comboLoaiTaiSanLoaded: true,
});

const getComboLoaiTaiSanSuccess = (state, action) => {
  return {
    ...state,
    loaiTaiSanLoading: false,
    comboLoaiTaiSan: action.payload,
    comboLoaiTaiSanLoaded: true,
  };
};

const getComboLoaiTaiSanFailed = (state, action) => ({
  ...state,
  loaiTaiSanLoading: false,
  comboLoaiTaiSan: [],
  comboLoaiTaiSanLoaded: true,
});

const postLoaiTaiSan = (state, action) => ({
  ...state,
  loaiTaiSanLoading: true,
});

const postLoaiTaiSanSuccess = (state, action) => {
  return {
    ...state,
    loaiTaiSanLoading: false,
  };
};

const postLoaiTaiSanFailed = (state, action) => ({
  ...state,
  loaiTaiSanLoading: false,
});
const showModalLoaiTaiSan = (state, action) => ({
  ...state,
  isShowModalLoaiTaiSan: action.dataPost,
});

const loaiTaiSanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_LOAI_TAI_SAN:
      return getComboLoaiTaiSan(state, action);
    case GET_COMBO_LOAI_TAI_SAN_SUCCESS:
      return getComboLoaiTaiSanSuccess(state, action);
    case GET_COMBO_LOAI_TAI_SAN_FAILURE:
      return getComboLoaiTaiSanFailed(state, action);
    case POST_LOAI_TAI_SAN_TM:
      return postLoaiTaiSan(state, action);
    case POST_LOAI_TAI_SAN_TM_SUCCESS:
      return postLoaiTaiSanSuccess(state, action);
    case POST_LOAI_TAI_SAN_TM_FAILURE:
      return postLoaiTaiSanFailed(state, action);
    case SHOW_MODAL_LOAI_TAI_SAN:
      return showModalLoaiTaiSan(state, action);
    default:
      return state;
  }
};

export default loaiTaiSanReducer;
